import Decimal from "decimal.js";
import CheckBoxPDF from "../components/pdfs/CheckboxPDF";
import commaNumber from "comma-number";

export const convertNameToValue = (data, name) => {
    const filteredItem = data?.find((item) => item.name === name);
    if (filteredItem) {
        if (filteredItem.type === "text box") {
            return filteredItem.value;
        } else if (filteredItem.type === "number box") {
            if (filteredItem.value) {
                return filteredItem.value;
            }
            return "";
        } else if (filteredItem.type === "datepicker box") {
            if (filteredItem.value === "Invalid Date") {
                return "";
            }
            return filteredItem.value;
        } else if (filteredItem.type === "lifetime box" || filteredItem.type === "temperature box") {
            if (!filteredItem.value) {
                return "";
            }
            return `${filteredItem.value} ${filteredItem.selectedUnit}`;
        } else if (filteredItem.type === "radio box") {
            return filteredItem.value;
        } else if (filteredItem.type === "check box") {
            return filteredItem.value.join(" , ");
        } else if (filteredItem.type === "img upload box") {
            return filteredItem.imgBase64;
        }
    }
};

export const convertNameToCheckbox = (data, name) => {
    const filteredItem = data?.find((item) => item.name === name);
    if (filteredItem) {
        return filteredItem.valueList.map((item, idx) => {
            if (item === filteredItem.value) {
                return <CheckBoxPDF key={idx} label={item} checked />;
            } else {
                return <CheckBoxPDF key={idx} label={item} />;
            }
        });
    }
};

export const averageValue = (...data) => {
    const total = [...data].filter((item) => item);
    if (total.length > 0) {
        const newTotal = total.map((item) => item?.replace(/,/g, ""));
        const sum = Decimal.sum(...newTotal);
        const average = sum.dividedBy(newTotal.length).toFixed(2);
        const insertComma = commaNumber(average);
        return insertComma;
    }
};
